import { useCallback, useRef, useState } from 'react'

import { TOUR_TARGETS } from 'partner360/configs/widgetTour/planningActivitiesTourTargets'

import { MdfActivitiesBreakdownChart } from '../../mdfActivitiesBreakdownChart/MdfActivitiesBreakdownChart'
import { MdfActivitiesInitiativesGroupsTable } from '../../mdfActivitiesInitiativesGroupsTable/MdfActivitiesInitiativesGroupsTable'
import { NO_INITIATIVE_ROW_ID } from '../../mdfActivitiesInitiativesGroupsTable/model/types'
import { MdfActivitiesStatusFunnel } from '../../mdfActivitiesStatusFunnel/MdfActivitiesStatusFunnel'
import { MdfAggregatedOverview } from '../../mdfAggregatedOverview/MdfAggregatedOverview'
import { MdfDashboardFilters } from '../../mdfDashboardFilters/MdfDashboardFilters'

import styles from './MdfDashboard.module.scss'

interface IMdfDashboardProps {
  partnerId: string
}

export const MdfDashboard = ({ partnerId }: IMdfDashboardProps) => {
  const [expandedGroupId, setExpandedGroupId] = useState<string | number | null>(
    NO_INITIATIVE_ROW_ID
  )
  const [showOnlyPendingOutcome, setShowOnlyPendingOutcome] = useState(false)
  const groupsTableRef = useRef<HTMLDivElement>(null)

  const scrollToGroupsTable = useCallback(() => {
    // let the detail rows render/expand before scrolling (the page grows)
    setTimeout(() => {
      groupsTableRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }, 100)
  }, [])

  const handleUnlinkedClick = useCallback(() => {
    setShowOnlyPendingOutcome(false)
    setExpandedGroupId(NO_INITIATIVE_ROW_ID)
    scrollToGroupsTable()
  }, [scrollToGroupsTable])

  const handleProvideOutcomeClick = useCallback(() => {
    setShowOnlyPendingOutcome(true)
    scrollToGroupsTable()
  }, [scrollToGroupsTable])

  return (
    <div className={styles.root}>
      <MdfDashboardFilters partnerId={partnerId} />

      <div data-tour-id={TOUR_TARGETS.mdfKpiTiles}>
        <MdfAggregatedOverview
          onUnlinkedClick={handleUnlinkedClick}
          onProvideOutcomeClick={handleProvideOutcomeClick}
        />
      </div>

      <div className={styles.charts} data-tour-id={TOUR_TARGETS.mdfCharts}>
        <MdfActivitiesBreakdownChart />
        <MdfActivitiesStatusFunnel />
      </div>

      <div ref={groupsTableRef} data-tour-id={TOUR_TARGETS.mdfLinkageTable}>
        <MdfActivitiesInitiativesGroupsTable
          partnerId={partnerId}
          expandedId={expandedGroupId}
          setExpandedId={setExpandedGroupId}
          showOnlyPendingOutcome={showOnlyPendingOutcome}
          setShowOnlyPendingOutcome={setShowOnlyPendingOutcome}
        />
      </div>
    </div>
  )
}

MdfDashboard.displayName = 'MdfDashboard'

export default MdfDashboard
